module.exports = __webpack_public_path__ + "media/images/area/feature/banner/pc/th_tohoku-c7e9318144579fe550b06601b76573a1.jpg";